import { ApiAudience } from "@incendium/api";
import { Chip, OutlinedTextFieldProps } from "@mui/material";
import { useAudiences } from "Hooks/useAudiences";
import StyledMultiSelect from "Components/UI/StyledMultiSelect";

interface IAudenceMultiSelectProps extends Omit<
  OutlinedTextFieldProps,
  "onChange"
> {
  values: ApiAudience[];
  disableClearable?: boolean;
  onChange: (audiences?: ApiAudience[]) => void;
}

function AudenceMultiSelect({
  values,
  label,
  helperText,
  variant,
  size,
  disableClearable,
  fullWidth,
  sx,
  onChange,
}: IAudenceMultiSelectProps) {
  const { audiences } = useAudiences();

  const getOptionLabel = (o: ApiAudience) =>
    o.name || audiences.find((a) => a.id === o.id)?.name || "";

  return (
    <StyledMultiSelect<ApiAudience>
      sx={sx}
      size={size}
      fullWidth={fullWidth}
      multiple
      options={audiences}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      value={values}
      onChange={(e, v) => {
        onChange(v);
      }}
      disableClearable={disableClearable}
      getOptionLabel={getOptionLabel}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              key={key}
              size={size}
              variant="outlined"
              color="primary"
              label={getOptionLabel(option)}
              {...tagProps}
            />
          );
        })
      }
      label={label}
      helperText={helperText}
      textFieldProps={{
        variant,
      }}
    />
  );
}

export default AudenceMultiSelect;
